import MapCenterCoord from 'Leaflet.MapCenterCoord/src/L.Control.MapCenterCoord.js'

import 'Leaflet.MapCenterCoord/src/L.Control.MapCenterCoord.css'

export default MapCenterCoord
